// --------------------------------------------------------------------------
// download.js
// --------------------------------------------------------------------------

RN.download = function() {

  'use strict';

  var options = {};

  function init() {
    options.checkboxs = byBehaviour('download-checkbox');
    options.button = byBehaviour('download-button');
    options.checkboxs.on('change', change);
    change();
  }

  function change(){
    options.button.attr('disabled', options.checkboxs.filter(':checked').length <= 0);
  }

  return {
    init: init
  };

}();